import type { FromModel, ModelDefinition } from "@/__main__/data-model.mjs";
import { Silent } from "@/__main__/data-model.mjs";
import { devError } from "@/util/dev.mjs";
import digPath from "@/util/dig-path.mjs";

export const DataBricksPath = {
  data: {
    executeDatabricksQuery: {
      payload: {
        result: {
          dataArray: [[Silent(String)]],
        },
      },
    },
  },
} satisfies ModelDefinition;

const digPathForPayload = [
  "data",
  "executeDatabricksQuery",
  "payload",
  "result",
  "dataArray",
];

export function fixDataLakeResponse<T>(
  response: FromModel<typeof DataBricksPath>,
  keys: readonly (keyof T)[],
): Array<{ [K in (typeof keys)[number]]: string }> {
  const [writePath, writeKey] = digPath(digPathForPayload, response);
  const dataArray: Array<Array<string>> | undefined = writePath?.[writeKey];
  // Guards
  if (!Array.isArray(dataArray?.[0])) {
    devError("Data lake response failed to dig path");
    return [];
  }
  const length = keys.length;
  // Guards: Bad matching length for data array or keys
  if (dataArray[0].length !== length) {
    // You need an equal length of data for the keys you wish to assign to them
    // Input ["Oliver", 21, true] === ["name", "age", "isCool"]
    // Output { name: "Oliver", age: 21, isCool: true }
    devError("Data lake data array response does not match the keys provided");
    return [];
  }
  const result = [];
  for (const data of dataArray) {
    const item = Object.create(null);
    for (let i = 0; i < length; i += 1) item[keys[i]] = data[i];
    result.push(item);
  }
  return result;
}
